function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 13.5,
  r: 13.5,
  fill: "#2C2B6C"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 13.5,
  r: 12.5,
  stroke: "white",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1925 12.8314L12.9091 12.7133L12.6756 12.9125L8.02171 16.8822L7.40217 17.4107L8.15374 17.7241L14.4999 20.3706L14.7833 20.4888L15.0168 20.2895L19.6707 16.3198L20.2902 15.7913L19.5386 15.4779L13.1925 12.8314Z",
  stroke: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6923 19.9092L2 14.6162L24 11.9697L14.6923 19.9092Z",
  fill: "#2C2B6C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1925 10.185L12.9091 10.0669L12.6756 10.2661L8.02171 14.2358L7.40217 14.7643L8.15374 15.0777L14.4999 17.7242L14.7833 17.8424L15.0168 17.6431L19.6707 13.6734L20.2902 13.1449L19.5386 12.8315L13.1925 10.185Z",
  fill: "#CBCBCB",
  stroke: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6923 17.2627L2 11.9697L24 9.32324L14.6923 17.2627Z",
  fill: "#2C2B6C"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1925 7.53852L12.9091 7.42035L12.6756 7.61959L8.02171 11.5893L7.40217 12.1178L8.15374 12.4312L14.4999 15.0777L14.7833 15.1958L15.0168 14.9966L19.6707 11.0269L20.2902 10.4984L19.5386 10.185L13.1925 7.53852Z",
  fill: "white",
  stroke: "white"
});

function SvgLayersTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersTooltip);
export default __webpack_public_path__ + "static/media/layers-tooltip.125730d2.svg";
export { ForwardRef as ReactComponent };